import ApiService from '@/services/apiService'

class DashboardService {
    /**
     * Get overall dashboard statistics
     * @param {Object} params - Query parameters
     * @param {string} params.date_from - Start date (YYYY-MM-DD)
     * @param {string} params.date_to - End date (YYYY-MM-DD)
     * @param {string} params.period - Period preset (today, week, month, quarter, year, custom)
     * @returns {Promise} Dashboard statistics
     */
    getDashboardStats(params = {}) {
        return ApiService.get('/dashboard', { params })
    }

    /**
     * Get sales statistics
     * @param {Object} params - Query parameters
     * @param {string} params.date_from - Start date (YYYY-MM-DD)
     * @param {string} params.date_to - End date (YYYY-MM-DD)
     * @param {string} params.group_by - Group by period (day, week, month, status)
     * @returns {Promise} Sales statistics
     */
    getSalesStats(params = {}) {
        return ApiService.get('/dashboard/sales', { params })
    }

    /**
     * Get product statistics
     * @param {Object} params - Query parameters
     * @param {number} params.category_id - Filter by category ID
     * @param {boolean} params.low_stock_only - Show only low stock products
     * @param {string} params.sort_by - Sort by field (name, sales, revenue, stock)
     * @param {string} params.sort_direction - Sort direction (asc, desc)
     * @returns {Promise} Product statistics
     */
    getProductStats(params = {}) {
        return ApiService.get('/dashboard/products', { params })
    }

    /**
     * Get customer statistics
     * @param {Object} params - Query parameters
     * @param {string} params.date_from - Start date (YYYY-MM-DD)
     * @param {string} params.date_to - End date (YYYY-MM-DD)
     * @param {number} params.limit - Limit for top customers (1-100)
     * @returns {Promise} Customer statistics
     */
    getCustomerStats(params = {}) {
        return ApiService.get('/dashboard/customers', { params })
    }

    /**
     * Get user statistics
     * @param {Object} params - Query parameters
     * @param {string} params.date_from - Start date (YYYY-MM-DD)
     * @param {string} params.date_to - End date (YYYY-MM-DD)
     * @returns {Promise} User statistics
     */
    getUserStats(params = {}) {
        return ApiService.get('/dashboard/users', { params })
    }

    /**
     * Get financial statistics
     * @param {Object} params - Query parameters
     * @param {string} params.date_from - Start date (YYYY-MM-DD)
     * @param {string} params.date_to - End date (YYYY-MM-DD)
     * @returns {Promise} Financial statistics
     */
    getFinancialStats(params = {}) {
        return ApiService.get('/dashboard/finance', { params })
    }
}

export default new DashboardService()